export default __webpack_public_path__ + "static/media/Sunset-Turbines-Narrow-480px-180px.jpg.1b504855.webp";